import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys } from "vue";
const _hoisted_1 = { class: "overflow-hidden transition-all duration-300 bg-white border shadow-sm group rounded-2xl border-ewhite-200 hover:shadow-xl hover:shadow-eorange-500/10 hover:border-eorange-300 hover:-translate-y-1" };
const _hoisted_2 = { class: "flex flex-col h-full p-0" };
const _hoisted_3 = { class: "px-5 pt-5 pb-4 border-b border-slate-100" };
const _hoisted_4 = { class: "flex items-start justify-between gap-3 mb-3" };
const _hoisted_5 = { class: "font-mono text-sm font-semibold leading-tight break-all text-foreground" };
const _hoisted_6 = { class: "font-mono text-sm leading-tight break-all text-foreground" };
const _hoisted_7 = { class: "text-lg font-bold text-foreground whitespace-nowrap" };
const _hoisted_8 = {
    class: "relative",
    ref: "badgeContainer"
};
const _hoisted_9 = {
    key: 0,
    class: "w-4 h-4 ml-0 text-foreground",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
};
const _hoisted_10 = {
    key: 1,
    class: "w-4 h-4 ml-0 text-foreground",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
};
const _hoisted_11 = { class: "py-1" };
const _hoisted_12 = ["onClick"];
const _hoisted_13 = { class: "flex-1" };
const _hoisted_14 = {
    key: 0,
    class: "flex items-center gap-2 mt-3 text-sm text-muted-foreground"
};
const _hoisted_15 = { class: "leading-tight" };
const _hoisted_16 = { class: "flex flex-col bg-eblack-100/80" };
const _hoisted_17 = { class: "flex flex-wrap p-1 -mb-px text-sm font-medium text-center text-gray-800 bg-slate-200 rounded-t-md" };
const _hoisted_18 = { class: "me-2" };
const _hoisted_19 = { class: "me-2" };
const _hoisted_20 = { class: "px-6 py-4 mt-auto border-t bg-ewhite-50/50 border-ewhite-100" };
const _hoisted_21 = { class: "flex gap-2" };
const _hoisted_22 = ["disabled"];
const _hoisted_23 = ["aria-labelledby", "aria-describedby"];
const _hoisted_24 = ["id"];
const _hoisted_25 = ["id"];
const _hoisted_26 = ["for"];
const _hoisted_27 = ["id", "disabled", "aria-invalid", "aria-describedby"];
const _hoisted_28 = ["id"];
const _hoisted_29 = {
    key: 1,
    role: "status",
    class: "mt-2 text-sm text-green-700"
};
const _hoisted_30 = { class: "flex justify-end gap-2 mt-6" };
const _hoisted_31 = ["disabled"];
const _hoisted_32 = ["disabled"];
const _hoisted_33 = ["aria-labelledby"];
const _hoisted_34 = { class: "w-full max-w-md p-5 bg-white border shadow-xl rounded-xl border-slate-200" };
const _hoisted_35 = ["id"];
const _hoisted_36 = { class: "mt-2 text-sm text-muted-foreground" };
const _hoisted_37 = { class: "mt-4 space-y-2 overflow-y-auto max-h-72" };
const _hoisted_38 = ["disabled", "onClick"];
const _hoisted_39 = { class: "flex flex-col" };
const _hoisted_40 = { class: "text-sm font-semibold text-foreground" };
const _hoisted_41 = { class: "text-xs text-muted-foreground" };
const _hoisted_42 = { class: "flex justify-end mt-5" };
const _hoisted_43 = {
    key: 0,
    class: "fixed inset-0 z-[10000] flex items-center justify-center bg-black/40 px-4"
};
const _hoisted_44 = { class: "w-full max-w-md p-5 bg-white border shadow-xl rounded-xl border-slate-200" };
const _hoisted_45 = { class: "text-base font-semibold text-foreground" };
const _hoisted_46 = { class: "mt-2 text-sm text-muted-foreground" };
const _hoisted_47 = { class: "flex justify-end gap-2 mt-5" };
const _hoisted_48 = ["disabled"];
import { ref, computed, nextTick, onMounted, onBeforeUnmount, watch } from "vue";
import { useAbility, useAuthStore } from "@/domains/auth";
import { useToast } from "vue-toastification";
import { getAllowedItineraryTransitions, getItineraryStateConfig, isAllowedItineraryStateTransition, ITINERARY_STATE, } from "@/domains/itinerary/models";
import { useItineraryStore } from "@/domains/itinerary/stores";
import InfoCardTab from "../components/CardTabs/InfoCardTab.vue";
import ScheduleCardTab from "../components/CardTabs/ScheduleCardTab.vue";
import CreatePdfButton from "../components/CardTabs/CreatePDFButton.vue";
import { IconCircleCheck, IconClock, IconEdit, IconMessageCircle, } from "@tabler/icons-vue";
import { useConversationCreation } from "@/domains/conversation";
import { formatCostaRicaDateTimeDisplay } from "@/domains/shared/utils/date-utils";
import { useItineraryI18n } from "@/domains/itinerary/composables";
import { itineraryApi } from "@/infrastructure/api/itinerary.api";
import { isAxiosError } from "axios";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ItineraryCard',
    props: {
        itinerary: {}
    },
    emits: ["show-modal", "status-updated"],
    setup(__props, { emit: __emit }) {
        const { findOrRedirect, isCreating: isCreatingConversation } = useConversationCreation();
        const { t } = useItineraryI18n();
        // Props & Emits
        const props = __props;
        const emit = __emit;
        // Authorization
        const { can } = useAbility();
        const authStore = useAuthStore();
        const isAdmin = computed(() => can("manage", "all"));
        const isConcierge = computed(() => !can("manage", "all") && can("manage", "Itinerary"));
        const canMarkItineraryPaid = computed(() => authStore.isSuperAdmin);
        const canUpdateState = computed(() => (isAdmin.value || isConcierge.value) && nextStateOptions.value.length > 0);
        const canResendEmail = computed(() => can("update", "Itinerary") && Boolean(props.itinerary.customer));
        // State
        const toast = useToast();
        const itineraryStore = useItineraryStore();
        const tab = ref(1);
        const showStateDropdown = ref(false);
        const updatingStatus = ref(false);
        const stateSelected = ref(props.itinerary.state);
        const showPaidCancelConfirmation = ref(false);
        const pendingStateChange = ref(null);
        const resendDialog = ref(null);
        const resendEmailInput = ref(null);
        const resendEmail = ref("");
        const resendRequestId = ref("");
        const resendSending = ref(false);
        const resendQueued = ref(false);
        const resendError = ref("");
        const dropdownPosition = ref({ top: 0, left: 0 });
        const badgeElement = ref(null);
        const dropdownElement = ref(null);
        // Computed
        const dropdownStyle = computed(() => ({
            top: `${dropdownPosition.value.top}px`,
            left: `${dropdownPosition.value.left}px`,
        }));
        const nextStateOptions = computed(() => getAllowedItineraryTransitions(props.itinerary.state).filter((stateOption) => stateOption.value !== ITINERARY_STATE.PAID || canMarkItineraryPaid.value));
        const isExpired = computed(() => props.itinerary.state === ITINERARY_STATE.EXPIRED);
        const isPaid = computed(() => props.itinerary.state === ITINERARY_STATE.PAID);
        const canShowArchiveActions = computed(() => !isExpired.value);
        const canShowChat = computed(() => isPaid.value && !isExpired.value);
        const canShowLifecycleTimestamp = computed(() => !isPaid.value);
        const lifecycleTimestamp = computed(() => {
            if (isExpired.value) {
                return {
                    label: t("itinerary.lifecycle.expired_at", "Expiró"),
                    value: formatDate(props.itinerary.state_updated_at ??
                        props.itinerary.updated_at ??
                        props.itinerary.expires_at, t("itinerary.lifecycle.unavailable_date", "Fecha no disponible")),
                };
            }
            if (props.itinerary.state === ITINERARY_STATE.CANCELLED) {
                return {
                    label: t("itinerary.lifecycle.cancelled_at", "Cancelado"),
                    value: formatDate(props.itinerary.state_updated_at ?? props.itinerary.updated_at, t("itinerary.lifecycle.unavailable_date", "Fecha no disponible")),
                };
            }
            return {
                label: t("itinerary.lifecycle.expiration_time", "Hora de expiración"),
                value: formatDate(props.itinerary.expires_at),
            };
        });
        // Methods
        async function openResendDialog() {
            const currentEmail = props.itinerary.customer?.email ?? "";
            if (!resendRequestId.value || resendQueued.value || resendEmail.value !== currentEmail) {
                resendEmail.value = currentEmail;
                newResend();
            }
            resendDialog.value?.showModal();
            await nextTick();
            resendEmailInput.value?.focus();
        }
        function newResend() {
            resendRequestId.value = crypto.randomUUID();
            resendQueued.value = false;
            resendError.value = "";
        }
        function resetResendRequest() {
            newResend();
        }
        async function submitResend() {
            if (resendSending.value || resendQueued.value)
                return;
            resendSending.value = true;
            resendError.value = "";
            try {
                await itineraryApi.resendEmail(props.itinerary.id, resendEmail.value, resendRequestId.value);
                resendQueued.value = true;
            }
            catch (error) {
                const status = isAxiosError(error) ? error.response?.status : undefined;
                resendError.value = t(status === 403 ? "itinerary_email_resend.forbidden" : status === 409 ? "itinerary_email_resend.conflict" : status === 400 || status === 422 ? "itinerary_email_resend.invalid" : "itinerary_email_resend.failed");
            }
            finally {
                resendSending.value = false;
            }
        }
        function toggleStateDropdown(event) {
            event.stopPropagation();
            if (nextStateOptions.value.length === 0)
                return;
            if (!showStateDropdown.value && badgeElement.value) {
                const rect = badgeElement.value.getBoundingClientRect();
                dropdownPosition.value = {
                    top: rect.bottom + 8,
                    left: rect.left,
                };
            }
            showStateDropdown.value = !showStateDropdown.value;
        }
        function updateItineraryState(newState) {
            const prevState = stateSelected.value;
            showStateDropdown.value = false;
            if (prevState === ITINERARY_STATE.PAID &&
                newState === ITINERARY_STATE.CANCELLED) {
                pendingStateChange.value = newState;
                showPaidCancelConfirmation.value = true;
                return;
            }
            if (newState !== prevState) {
                updateItineraryStatus(newState);
            }
        }
        function handleShowModal() {
            emit("show-modal", props.itinerary);
        }
        function cancelPaidStateChange() {
            pendingStateChange.value = null;
            showPaidCancelConfirmation.value = false;
        }
        function confirmPaidCancel() {
            const nextState = pendingStateChange.value;
            if (!nextState)
                return;
            showPaidCancelConfirmation.value = false;
            pendingStateChange.value = null;
            updateItineraryStatus(nextState);
        }
        async function updateItineraryStatus(newStatus) {
            if (updatingStatus.value)
                return;
            if (newStatus === ITINERARY_STATE.PAID && !canMarkItineraryPaid.value) {
                toast.error(t("itinerary.lifecycle.paid_requires_superadmin", "Solo un superadmin de Emanta puede marcar un itinerario como pagado"));
                stateSelected.value = props.itinerary.state;
                return;
            }
            if (!isAllowedItineraryStateTransition(props.itinerary.state, newStatus)) {
                toast.error(t("itinerary.lifecycle.transition_not_allowed", "Transición de estado no permitida"));
                return;
            }
            updatingStatus.value = true;
            try {
                const updatedItinerary = await itineraryStore.updateState(props.itinerary.id, newStatus);
                stateSelected.value = newStatus;
                emit("status-updated", {
                    id: props.itinerary.id,
                    state: newStatus,
                    itinerary: updatedItinerary,
                });
                toast.success(t("itinerary.lifecycle.state_update_success", { state: getStateName(newStatus) }, "Estado actualizado a {state}"));
            }
            catch (error) {
                console.error("Error updating itinerary status:", error);
                stateSelected.value = props.itinerary.state;
                toast.error(t("itinerary.lifecycle.state_update_error", "Error al actualizar el estado del itinerario"));
            }
            finally {
                updatingStatus.value = false;
            }
        }
        function getStateName(state) {
            const stateConfig = getItineraryStateConfig(state);
            return t(stateConfig.labelKey, stateConfig.label);
        }
        function stateOptionLabel(stateOption) {
            return t(stateOption.transitionLabelKey, stateOption.transitionLabel);
        }
        function getStateColor(state) {
            return getItineraryStateConfig(state).badgeClass;
        }
        function formatDate(ISOdate, fallback = t("itinerary.lifecycle.no_expiration", "Sin expiración")) {
            return formatCostaRicaDateTimeDisplay(ISOdate, fallback);
        }
        function handleClickOutside(event) {
            if (showStateDropdown.value) {
                const clickedInsideDropdown = dropdownElement.value &&
                    dropdownElement.value.contains(event.target);
                const clickedInsideBadge = badgeElement.value && badgeElement.value.contains(event.target);
                if (!clickedInsideDropdown && !clickedInsideBadge) {
                    showStateDropdown.value = false;
                }
            }
        }
        // Lifecycle
        onMounted(() => {
            document.addEventListener("click", handleClickOutside);
        });
        onBeforeUnmount(() => {
            document.removeEventListener("click", handleClickOutside);
        });
        watch(() => props.itinerary.state, (state) => {
            stateSelected.value = state;
        });
        // Chat
        const showChatProviderPicker = ref(false);
        const bookingLines = computed(() => props.itinerary.slots_itineraries ?? []);
        async function handleOpenChat() {
            if (!canShowChat.value)
                return;
            if (bookingLines.value.length === 0)
                return;
            // Each booking line may belong to a different provider, so the concierge
            // must choose which conversation to open.
            if (bookingLines.value.length > 1) {
                showChatProviderPicker.value = true;
                return;
            }
            await openChatForBookingLine(bookingLines.value[0]);
        }
        async function handleSelectChatProvider(bookingLine) {
            showChatProviderPicker.value = false;
            await openChatForBookingLine(bookingLine);
        }
        function openChatForBookingLine(bookingLine) {
            return findOrRedirect({
                serviceId: String(bookingLine.service?.id ?? bookingLine.service_id ?? ""),
                providerId: String(bookingLine.service?.provider?.id ?? bookingLine.provider_id ?? ""),
                itineraryId: String(props.itinerary.id),
                bookingId: String(bookingLine.booking_id ?? bookingLine.id ?? ""),
                slotId: String(bookingLine.service_slot_id ?? bookingLine.service_slot?.id ?? ""),
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", null, [
                                _createElementVNode("h3", _hoisted_5, _toDisplayString(__props.itinerary.code), 1),
                                _createElementVNode("h3", _hoisted_6, _toDisplayString(_unref(t)("itinerary.card.created", "Creada")) + ": " + _toDisplayString(formatDate(__props.itinerary.created_at)), 1)
                            ]),
                            _createElementVNode("span", _hoisted_7, "$" + _toDisplayString(__props.itinerary.total), 1)
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                            (canUpdateState.value)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    ref_key: "badgeElement",
                                    ref: badgeElement,
                                    "data-testid": "itinerary-state-badge",
                                    class: _normalizeClass(["inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium cursor-pointer select-none", getStateColor(__props.itinerary.state)]),
                                    onClick: toggleStateDropdown
                                }, [
                                    _createVNode(_unref(IconCircleCheck), { class: "w-3 h-3 mr-1" }),
                                    _createTextVNode(" " + _toDisplayString(getStateName(__props.itinerary.state)) + " ", 1),
                                    (nextStateOptions.value.length > 0 && !showStateDropdown.value)
                                        ? (_openBlock(), _createElementBlock("svg", _hoisted_9, [...(_cache[9] || (_cache[9] = [
                                                _createElementVNode("path", { d: "m6 9 6 6 6-6" }, null, -1)
                                            ]))]))
                                        : (nextStateOptions.value.length > 0)
                                            ? (_openBlock(), _createElementBlock("svg", _hoisted_10, [...(_cache[10] || (_cache[10] = [
                                                    _createElementVNode("path", { d: "m18 15-6-6-6 6" }, null, -1)
                                                ]))]))
                                            : _createCommentVNode("", true)
                                ], 2))
                                : (_openBlock(), _createElementBlock("span", {
                                    key: 1,
                                    class: _normalizeClass(["inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium select-none", getStateColor(__props.itinerary.state)])
                                }, [
                                    _createVNode(_unref(IconCircleCheck), { class: "w-3 h-3 mr-1" }),
                                    _createTextVNode(" " + _toDisplayString(getStateName(__props.itinerary.state)), 1)
                                ], 2)),
                            (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                                (showStateDropdown.value && canUpdateState.value)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        ref_key: "dropdownElement",
                                        ref: dropdownElement,
                                        class: "fixed z-[9999] w-48 bg-white border border-slate-200 rounded-xl shadow-xl overflow-hidden",
                                        style: _normalizeStyle(dropdownStyle.value)
                                    }, [
                                        _createElementVNode("ul", _hoisted_11, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nextStateOptions.value, (stateOption) => {
                                                return (_openBlock(), _createElementBlock("li", {
                                                    key: stateOption.value,
                                                    "data-testid": "itinerary-state-option",
                                                    onClick: ($event) => (updateItineraryState(stateOption.value)),
                                                    class: _normalizeClass(["px-4 py-2.5 text-sm font-medium cursor-pointer transition-all duration-150 flex items-center gap-2 hover:bg-slate-50 active:bg-slate-100", stateOption.menuClass])
                                                }, [
                                                    _cache[11] || (_cache[11] = _createElementVNode("span", { class: "flex-shrink-0" }, [
                                                        _createElementVNode("svg", {
                                                            class: "w-4 h-4 opacity-50",
                                                            fill: "none",
                                                            stroke: "currentColor",
                                                            viewBox: "0 0 24 24"
                                                        }, [
                                                            _createElementVNode("circle", {
                                                                cx: "12",
                                                                cy: "12",
                                                                r: "10",
                                                                "stroke-width": "2"
                                                            })
                                                        ])
                                                    ], -1)),
                                                    _createElementVNode("span", _hoisted_13, _toDisplayString(stateOptionLabel(stateOption)), 1)
                                                ], 10, _hoisted_12));
                                            }), 128))
                                        ])
                                    ], 4))
                                    : _createCommentVNode("", true)
                            ]))
                        ], 512),
                        (canShowLifecycleTimestamp.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _createVNode(_unref(IconClock), { class: "w-4 h-4 text-slate-400" }),
                                _createElementVNode("span", _hoisted_15, _toDisplayString(lifecycleTimestamp.value.label) + ": " + _toDisplayString(lifecycleTimestamp.value.value), 1)
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", null, [
                            _createElementVNode("ul", _hoisted_17, [
                                _createElementVNode("li", _hoisted_18, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        onClick: _cache[0] || (_cache[0] = ($event) => (tab.value = 1)),
                                        class: _normalizeClass([[
                                                tab.value == 1 ? 'border-eorange-300 ' : 'border-transparent',
                                            ], "inline-flex items-center justify-center p-2 text-xs border-b-2 rounded-t-lg hover:text-gray-600 hover:border-gray-300 group"])
                                    }, [
                                        _cache[12] || (_cache[12] = _createElementVNode("svg", {
                                            class: "w-4 h-4 text-gray-400 me-2 group-hover:text-gray-500",
                                            "aria-hidden": "true",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            fill: "currentColor",
                                            viewBox: "0 0 18 20"
                                        }, [
                                            _createElementVNode("path", { d: "M16 1h-3.278A1.992 1.992 0 0 0 11 0H7a1.993 1.993 0 0 0-1.722 1H2a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2Zm-3 14H5a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2Zm0-4H5a1 1 0 0 1 0-2h8a1 1 0 1 1 0 2Zm0-5H5a1 1 0 0 1 0-2h2V2h4v2h2a1 1 0 1 1 0 2Z" })
                                        ], -1)),
                                        _createTextVNode(" " + _toDisplayString(_unref(t)("itinerary.card.information", "Información")), 1)
                                    ], 2)
                                ]),
                                _createElementVNode("li", _hoisted_19, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        onClick: _cache[1] || (_cache[1] = ($event) => (tab.value = 2)),
                                        class: _normalizeClass([[
                                                tab.value == 2 ? 'border-eorange-300 ' : 'border-transparent',
                                            ], "inline-flex items-center justify-center p-2 text-xs border-b-2 rounded-t-lg hover:text-gray-600 hover:border-gray-300 group"])
                                    }, [
                                        _cache[13] || (_cache[13] = _createElementVNode("svg", {
                                            class: "w-4 h-4 text-gray-400 me-2 group-hover:text-gray-500",
                                            "aria-hidden": "true",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "24",
                                            height: "24",
                                            fill: "currentColor",
                                            viewBox: "0 0 24 24"
                                        }, [
                                            _createElementVNode("path", {
                                                "fill-rule": "evenodd",
                                                d: "M5 5a1 1 0 0 0 1-1 1 1 0 1 1 2 0 1 1 0 0 0 1 1h1a1 1 0 0 0 1-1 1 1 0 1 1 2 0 1 1 0 0 0 1 1h1a1 1 0 0 0 1-1 1 1 0 1 1 2 0 1 1 0 0 0 1 1 2 2 0 0 1 2 2v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a2 2 0 0 1 2-2ZM3 19v-7a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Zm6.01-6a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm2 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm6 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm-10 4a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm6 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm2 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z",
                                                "clip-rule": "evenodd"
                                            })
                                        ], -1)),
                                        _createTextVNode(" " + _toDisplayString(_unref(t)("itinerary.card.schedule", "Cronograma")), 1)
                                    ], 2)
                                ])
                            ])
                        ])
                    ]),
                    _withDirectives(_createVNode(InfoCardTab, { itinerary: __props.itinerary }, null, 8, ["itinerary"]), [
                        [_vShow, tab.value == 1]
                    ]),
                    _withDirectives(_createVNode(ScheduleCardTab, { itinerary: __props.itinerary }, null, 8, ["itinerary"]), [
                        [_vShow, tab.value == 2]
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                            _createVNode(CreatePdfButton, { itinerary: __props.itinerary }, null, 8, ["itinerary"]),
                            (canResendEmail.value)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    class: "px-4 py-1 text-sm border rounded-xl border-eorange-200 text-eorange-700 bg-eorange-50 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-eorange-600",
                                    onClick: openResendDialog
                                }, _toDisplayString(_unref(t)("itinerary_email_resend.action")), 1))
                                : _createCommentVNode("", true),
                            (canShowArchiveActions.value)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    type: "button",
                                    class: "flex gap-1 px-4 py-1 text-sm text-white bg-eblue-500 rounded-xl item-center",
                                    onClick: _cache[2] || (_cache[2] = ($event) => (handleShowModal()))
                                }, [
                                    _createVNode(_unref(IconEdit), {
                                        class: "w-5 h-5",
                                        stroke: "{2}"
                                    }),
                                    _createElementVNode("span", null, _toDisplayString(_unref(t)("itinerary.actions.edit", "Editar")), 1)
                                ]))
                                : _createCommentVNode("", true),
                            (canShowChat.value)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 2,
                                    type: "button",
                                    disabled: _unref(isCreatingConversation),
                                    class: "flex gap-1 px-4 py-1 text-sm transition-colors border text-eorange-600 bg-eorange-50 border-eorange-200 rounded-xl item-center hover:bg-eorange-100 disabled:opacity-50 disabled:cursor-not-allowed",
                                    onClick: handleOpenChat
                                }, [
                                    _createVNode(_unref(IconMessageCircle), {
                                        class: "w-5 h-5",
                                        stroke: "{2}"
                                    }),
                                    _createElementVNode("span", null, _toDisplayString(_unref(isCreatingConversation)
                                        ? _unref(t)("itinerary.actions.opening", "Abriendo...")
                                        : _unref(t)("itinerary.actions.chat", "Chat")), 1)
                                ], 8, _hoisted_22))
                                : _createCommentVNode("", true)
                        ])
                    ])
                ]),
                (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                    _createElementVNode("dialog", {
                        ref_key: "resendDialog",
                        ref: resendDialog,
                        class: "w-[min(90vw,28rem)] rounded-xl p-0 shadow-xl backdrop:bg-black/40",
                        "aria-labelledby": `resend-title-${__props.itinerary.id}`,
                        "aria-describedby": `resend-description-${__props.itinerary.id}`,
                        onCancel: _cache[5] || (_cache[5] = ($event) => (resendSending.value && $event.preventDefault()))
                    }, [
                        _createElementVNode("form", {
                            class: "p-6",
                            onSubmit: _withModifiers(submitResend, ["prevent"])
                        }, [
                            _createElementVNode("h2", {
                                class: "text-lg font-semibold",
                                id: `resend-title-${__props.itinerary.id}`
                            }, _toDisplayString(_unref(t)("itinerary_email_resend.title")), 9, _hoisted_24),
                            _createElementVNode("p", {
                                class: "mt-2 text-sm text-slate-700",
                                id: `resend-description-${__props.itinerary.id}`
                            }, _toDisplayString(_unref(t)("itinerary_email_resend.description")), 9, _hoisted_25),
                            _createElementVNode("label", {
                                class: "block mt-5 text-sm font-medium",
                                for: `resend-email-${__props.itinerary.id}`
                            }, _toDisplayString(_unref(t)("itinerary_email_resend.email")), 9, _hoisted_26),
                            _withDirectives(_createElementVNode("input", {
                                id: `resend-email-${__props.itinerary.id}`,
                                ref_key: "resendEmailInput",
                                ref: resendEmailInput,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((resendEmail).value = $event)),
                                type: "email",
                                required: "",
                                autocomplete: "email",
                                disabled: resendSending.value || resendQueued.value,
                                class: "block w-full mt-1 rounded-lg border-slate-300 focus:border-eorange-500 focus:ring-eorange-500",
                                "aria-invalid": Boolean(resendError.value),
                                "aria-describedby": resendError.value ? `resend-error-${__props.itinerary.id}` : `resend-description-${__props.itinerary.id}`,
                                onInput: resetResendRequest
                            }, null, 40, _hoisted_27), [
                                [
                                    _vModelText,
                                    resendEmail.value,
                                    void 0,
                                    { trim: true }
                                ]
                            ]),
                            (resendError.value)
                                ? (_openBlock(), _createElementBlock("p", {
                                    key: 0,
                                    id: `resend-error-${__props.itinerary.id}`,
                                    role: "alert",
                                    class: "mt-2 text-sm text-red-700"
                                }, _toDisplayString(resendError.value), 9, _hoisted_28))
                                : _createCommentVNode("", true),
                            (resendQueued.value)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(_unref(t)("itinerary_email_resend.queued")), 1))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_30, [
                                _createElementVNode("button", {
                                    type: "button",
                                    disabled: resendSending.value,
                                    class: "px-4 py-2 text-sm rounded-lg border border-slate-300 disabled:opacity-60",
                                    onClick: _cache[4] || (_cache[4] = ($event) => (resendDialog.value?.close()))
                                }, _toDisplayString(_unref(t)("itinerary_email_resend.close")), 9, _hoisted_31),
                                (resendQueued.value)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        class: "px-4 py-2 text-sm rounded-lg border border-eorange-300",
                                        onClick: newResend
                                    }, _toDisplayString(_unref(t)("itinerary_email_resend.another")), 1))
                                    : (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        type: "submit",
                                        disabled: resendSending.value,
                                        class: "px-4 py-2 text-sm text-white rounded-lg bg-eorange-600 disabled:opacity-60"
                                    }, _toDisplayString(resendSending.value ? _unref(t)("itinerary_email_resend.sending") : _unref(t)("itinerary_email_resend.submit")), 9, _hoisted_32))
                            ])
                        ], 32)
                    ], 40, _hoisted_23)
                ])),
                (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                    (showChatProviderPicker.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            "data-testid": "chat-provider-picker",
                            class: "fixed inset-0 z-[10000] flex items-center justify-center bg-black/40 px-4",
                            role: "dialog",
                            "aria-modal": "true",
                            "aria-labelledby": `chat-provider-title-${__props.itinerary.id}`,
                            onClick: _cache[7] || (_cache[7] = _withModifiers(($event) => (showChatProviderPicker.value = false), ["self"])),
                            onKeydown: _cache[8] || (_cache[8] = _withKeys(($event) => (showChatProviderPicker.value = false), ["esc"]))
                        }, [
                            _createElementVNode("div", _hoisted_34, [
                                _createElementVNode("h2", {
                                    id: `chat-provider-title-${__props.itinerary.id}`,
                                    class: "text-base font-semibold text-foreground"
                                }, _toDisplayString(_unref(t)("itinerary.card.chat_provider_title", "Selecciona el proveedor")), 9, _hoisted_35),
                                _createElementVNode("p", _hoisted_36, _toDisplayString(_unref(t)("itinerary.card.chat_provider_description", "Este itinerario tiene varios servicios. Elige con qué proveedor deseas conversar.")), 1),
                                _createElementVNode("ul", _hoisted_37, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bookingLines.value, (line) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                            key: line.id
                                        }, [
                                            _createElementVNode("button", {
                                                type: "button",
                                                "data-testid": "chat-provider-option",
                                                disabled: _unref(isCreatingConversation),
                                                class: "flex items-center w-full gap-3 px-4 py-3 text-left transition-colors border rounded-lg border-slate-200 hover:border-eorange-300 hover:bg-eorange-50 disabled:opacity-50 disabled:cursor-not-allowed",
                                                onClick: ($event) => (handleSelectChatProvider(line))
                                            }, [
                                                _createVNode(_unref(IconMessageCircle), { class: "flex-shrink-0 w-5 h-5 text-eorange-600" }),
                                                _createElementVNode("span", _hoisted_39, [
                                                    _createElementVNode("span", _hoisted_40, _toDisplayString(line.service?.provider?.name ||
                                                        _unref(t)("itinerary.card.chat_provider_unknown", "Proveedor")), 1),
                                                    _createElementVNode("span", _hoisted_41, _toDisplayString(line.service?.name), 1)
                                                ])
                                            ], 8, _hoisted_38)
                                        ]));
                                    }), 128))
                                ]),
                                _createElementVNode("div", _hoisted_42, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        "data-testid": "chat-provider-picker-cancel",
                                        class: "px-4 py-2 text-sm border rounded-lg border-slate-200 text-foreground",
                                        onClick: _cache[6] || (_cache[6] = ($event) => (showChatProviderPicker.value = false))
                                    }, _toDisplayString(_unref(t)("itinerary.actions.cancel", "Cancelar")), 1)
                                ])
                            ])
                        ], 40, _hoisted_33))
                        : _createCommentVNode("", true)
                ])),
                (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                    (showPaidCancelConfirmation.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                            _createElementVNode("div", _hoisted_44, [
                                _createElementVNode("h2", _hoisted_45, _toDisplayString(_unref(t)("itinerary.lifecycle.paid_cancel_title", "Confirmar cancelación")), 1),
                                _createElementVNode("p", _hoisted_46, _toDisplayString(_unref(t)("itinerary.lifecycle.paid_cancel_body", "Este itinerario ya está pagado. ¿Desea cancelarlo?")), 1),
                                _createElementVNode("div", _hoisted_47, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        "data-testid": "cancel-paid-cancel",
                                        class: "px-4 py-2 text-sm border rounded-lg border-slate-200 text-foreground",
                                        onClick: cancelPaidStateChange
                                    }, _toDisplayString(_unref(t)("itinerary.actions.back", "Volver")), 1),
                                    _createElementVNode("button", {
                                        type: "button",
                                        "data-testid": "confirm-paid-cancel",
                                        class: "px-4 py-2 text-sm text-white bg-red-600 rounded-lg disabled:opacity-50",
                                        disabled: updatingStatus.value,
                                        onClick: confirmPaidCancel
                                    }, _toDisplayString(_unref(t)("itinerary.actions.confirm", "Confirmar")), 9, _hoisted_48)
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ]))
            ]));
        };
    }
});
